import { Grid } from "@mui/material";
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import AllForms from "./AllForm";
import { ButtonFooter } from "../../../../components";
import HeadersAndButtons from "./AllButons";

export default function FormDisplay({
  audiences,
  editState,
  liveUsers,
  categories,
  formikProps,
  takeUpOffer,
  audienceData,
  setEditState,
  component = "",
  brandDetails,
  setTakeUpOffer,
  setBrandDetails,
  setAudienceData,
  setAudienceCreated,
  preferredChannels,
  connectionList,
  audienceSize,
}) {
  const channelSectionRef = useRef(null);
  const [tabValue, setTabValue] = useState("Campaign");

  const [isSubmitted, setIsSubmitted] = useState(() =>
    checkChannelFields(formikProps.values)
  );
  const [forceClick, setForceClick] = useState(true);
  const [brandIdentity, setBrandIdentity] = useState(false);

  const { activeBrand } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    if (formikProps.values.brandID) {
      if (parseInt(formikProps.values.brandID) !== parseInt(activeBrand.ID)) {
        setBrandIdentity(true);
      }
    }
  }, [formikProps.values.brandID, activeBrand.ID]);

  return (
    <Grid container spacing={4}>
      <HeadersAndButtons
        channelSectionRef={channelSectionRef}
        editState={editState}
        liveUsers={liveUsers}
        formikProps={formikProps}
        setEditState={setEditState}
        component={component}
        setTakeUpOffer={setTakeUpOffer}
        connectionList={connectionList}
        preferredChannels={preferredChannels}
        forceClick={forceClick}
        setForceClick={setForceClick}
        audienceSize={audienceSize}
        brandIdentity={brandIdentity}
        setIsSubmitted={setIsSubmitted}
        isSubmitted={isSubmitted}
        activeBrand={activeBrand}
        tabValue={tabValue}
        setTabValue={setTabValue}
      />

      <AllForms
        tabValue={tabValue}
        channelSectionRef={channelSectionRef}
        audienceData={audienceData}
        audiences={audiences}
        editState={editState}
        liveUsers={liveUsers}
        categories={categories}
        formikProps={formikProps}
        takeUpOffer={takeUpOffer}
        brandDetails={brandDetails}
        component={component}
        setBrandDetails={setBrandDetails}
        setAudienceData={setAudienceData}
        setAudienceCreated={setAudienceCreated}
        preferredChannels={preferredChannels}
        forceClick={forceClick}
        isSubmitted={isSubmitted}
        audienceSize={audienceSize}
      />

      {editState && (
        <Grid size={12}>
          <ButtonFooter
            ID={formikProps.values.campaignID}
            editState={editState}
            setEditState={setEditState}
            formikProps={formikProps}
          />
        </Grid>
      )}
    </Grid>
  );
}

export function checkChannelFields(values) {
  const prefChannels = values?.pref_campaign_channel?.value || [];

  let requiredFields = [];

  if (prefChannels.includes(3)) {
    requiredFields.push("ad_manager_id");
  }

  if (prefChannels.includes(6)) {
    requiredFields.push(
      "dv_partner_id",
      "dv_advertiser_id",
      "dv_advertiser_name"
    );
  }

  // remove duplicates in case both 3 and 6 are selected
  requiredFields = [...new Set(requiredFields)];

  return requiredFields.every((field) => !!values?.[field]?.value);
}
